var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhyblazing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 101,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#why_blazing_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_blazing_svg__b)",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_blazing_svg__c)",
  fillRule: "evenodd",
  d: "M19.306 88.429c5.07.278 13.147.57 24.694.57s19.625-.292 24.695-.57c5.033-.276 9.128-3.569 9.604-8.091.365-3.465.701-8.509.701-15.339s-.336-11.873-.7-15.336c-.477-4.524-4.572-7.817-9.605-8.093C63.625 41.292 55.547 41 44 41s-19.625.292-24.694.57c-5.034.276-9.128 3.569-9.605 8.091C9.336 53.127 9 58.17 9 65c0 6.83.336 11.874.7 15.337.478 4.524 4.572 7.817 9.606 8.093",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("rect", {
  width: 52.513,
  height: 35.282,
  x: 16.744,
  y: 36.384,
  fill: "#fff",
  rx: 17.641
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#why_blazing_svg__d)",
  d: "M43 29c-17.672 0-32 14.559-32 32.532a32.74 32.74 0 0 0 8.043 21.577c.157.174.3.348.457.508 1.26 1.177 1.643 1.177 2.643 1.177s1.657 0 2.657-1.19c4.333-5.162 11-7.393 18.2-7.393s13.876 2.24 18.2 7.392c1 1.191 1.643 1.191 2.657 1.191s1.507 0 2.643-1.177c.163-.168.3-.334.457-.508A32.74 32.74 0 0 0 75 61.532C75 43.56 60.672 29 43 29m-2.133 8.583h4.266v8.584h-4.266zm-12.8 25.752h-8.534v-4.292h8.534zm2.865-11.25-6.033-6.07 3.016-3.035 6.034 6.07zM46.013 63.79c-.259.361-.574.678-.933.939a3.996 3.996 0 0 1-5.564-.965 4.057 4.057 0 0 1 .897-5.607l11.12-5.553zm6.038-14.741 6.034-6.07 3.016 3.034-6.033 6.07zm14.416 14.285h-8.534v-4.292h8.534z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#why_blazing_svg__e)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41.75,
  height: 33.4,
  x: 50,
  y: 56.999,
  fill: "#fff",
  fillOpacity: 0.1,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 41.55,
  height: 33.2,
  x: 50.1,
  y: 57.099,
  stroke: "url(#why_blazing_svg__f)",
  strokeWidth: 0.2,
  rx: 3.9
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M77.876 64.3c.946-2.275-.3-4.39-2.181-3.252-3.525 2.136-6.775 4.67-10.094 7.568-1.658 1.445-1.785 4.314-.289 4.937l2.428 1.009-2.894 6.96c-.945 2.271.3 4.385 2.178 3.251 3.527-2.14 6.778-4.678 10.097-7.567 1.655-1.446 1.785-4.314.286-4.937l-2.425-1.009z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_blazing_svg__c",
  x1: 29.82,
  x2: 70.246,
  y1: 43.972,
  y2: 89.826,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2A849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF0084"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_blazing_svg__d",
  x1: 11,
  x2: 95.909,
  y1: 57.179,
  y2: 59.228,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "why_blazing_svg__f",
  x1: 50,
  x2: 105.384,
  y1: 73.868,
  y2: 75.325,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_blazing_svg__b",
  width: 94,
  height: 72,
  x: -3,
  y: 29,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_20508_13644",
  stdDeviation: 6
})), /*#__PURE__*/React.createElement("filter", {
  id: "why_blazing_svg__e",
  width: 49.75,
  height: 41.4,
  x: 46,
  y: 52.999,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_20508_13644"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_20508_13644",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.988235 0 0 0 0 0.0941176 0 0 0 0 0.52549 0 0 0 0.36 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_20508_13644"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "why_blazing_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100,
  y: 0.883,
  fill: "#fff",
  rx: 20
})))));
export { SvgWhyblazing as ReactComponent };
export default __webpack_public_path__ + "static/media/why.blazing.93cfa706.svg";